<div style="width: 100%;">
    <mat-tab-group>
      <mat-tab label="Synchronisationsvorgänge">
            <app-synchronisations></app-synchronisations>
      </mat-tab>
      <mat-tab label="Uploads"><app-uploads></app-uploads></mat-tab>
    </mat-tab-group>
</div>
